var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Copy richly formatted text.
 *
 * @param {string} rich - the text formatted as HTML
 * @param {string} plain - a plain text fallback
 * @link https://stackoverflow.com/questions/23934656/how-can-i-copy-rich-text-contents-to-the-clipboard-with-javascript/77305170#77305170
 */
export const copyRichText = (rich, plain) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof ClipboardItem !== 'undefined') {
        // Shiny new Clipboard API, not fully supported in Firefox.
        // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API#browser_compatibility
        const html = new Blob([rich], { type: 'text/html' });
        const text = new Blob([plain], { type: 'text/plain' });
        const data = new ClipboardItem({ 'text/html': html, 'text/plain': text });
        yield navigator.clipboard.write([data]);
    }
    else {
        // Fallback using the deprecated `document.execCommand`.
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand#browser_compatibility
        const cb = (e) => {
            var _a, _b;
            (_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.setData('text/html', rich);
            (_b = e.clipboardData) === null || _b === void 0 ? void 0 : _b.setData('text/plain', plain);
            e.preventDefault();
        };
        document.addEventListener('copy', cb);
        document.execCommand('copy');
        document.removeEventListener('copy', cb);
    }
});
